// @flow
import React, { Component } from 'react'
import glamorous from 'glamorous'
import getContent from 'pp-react-l10n'
import { withRouter } from 'react-router-dom'
import { LoadingSpinner as Spinner } from '@paypalcorp/pp-react'
import type { RouterHistory } from 'react-router'
import clientData from 'utils/client-data'
import _ from 'lodash'
import { isNativeApp } from 'utils/venice'
import { SPINNER_ID } from 'utils/loader'
import {
  INSTRUMENTATION_MAP,
  SELLER_INSTRUMENTATION_MAP,
} from 'utils/constants'
import { tracking, trackAction } from '../../lib/analytics'
import Events from 'lib/analytics/event-tags'
import {
  phoneLandscapeMaxAndSmaller,
  tabletLandscapeMaxAndSmaller,
  phoneLandscapeMinAndSmaller,
} from '../../lib/styles/media-queries'
const l10n = getContent('pages/settings')
const Wrapper = glamorous.div({
  position: 'absolute',
  zIndex: '1050',
  width: '100%',
  height: '100%',
  background: '#f4f6f9',
  display: 'table',
  tableLayout: 'fixed',
  top: '0',
})
const SpinnerContainer = glamorous.div({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  animation: 'vx_fade-in 0.3s ease-out 0s both',
  zIndex: 1,
})
const White = glamorous.div(props => ({
  position: 'fixed',
  right: 0,
  left: 0,
  // super important for animations to work because as our route
  // "leaves" to the right/left of the screen, it will be hidden
  overflow: 'hidden',
  overflowY: 'auto',
  width: props.WhiteWidth,
  height: '100%',
  maxWidth: !props.isFullScreen && '700px',
  margin: '0 auto',
  padding: '0 20px',
  background:
    props.isSellerDashboardPreview || props.isSellerProducts
      ? 'none'
      : '#ffffff',
  [phoneLandscapeMaxAndSmaller]: {
    width: '100%',
    padding: props.isMyProfile ? '0' : '0 20px',
  },
}))
const Content = glamorous.div(props => ({
  marginTop: props.contentMarginTop,
  marginBottom: props.isFullScreen ? 0 : 104,
  padding: !props.isSellerProfile
    ? '0 25%'
    : props.widerPage
    ? '0 13%'
    : '0 25%',
  [tabletLandscapeMaxAndSmaller]: {
    padding: '0 12.5%',
  },
  [phoneLandscapeMaxAndSmaller]: {
    padding: '0 8.33%',
  },
  [phoneLandscapeMinAndSmaller]: {
    padding: '0',
  },
}))
// the x and back button on the modal corners has a weird bounding
// box due to use of padding instead of margin
const navigationItemStylingFix = {
  padding: 0,
  margin: '24px 4px 0',
  cursor: 'pointer',
}
const NavLink = glamorous.a(
  'vx_backBtn vx_backBtn_flow',
  navigationItemStylingFix,
  {
    display: 'flex',
    alignItems: 'center',
    height: '1.5em',

    // these overrides are to ensure the back arrow always points backwards
    // this overrides the [dir=rtl] style ruls from vx
    ':before': {
      verticalAlign: 'inherit',
      transform: 'none',
      marginTop: -2,
    },
  },
)

type NavigationProps = {
  history: RouterHistory,
  isMyProfile: boolean,
  isSettingsPage: boolean,
  isTimeoutPage: boolean,
  isSellerDashboard: boolean,
  isSuccessPage: boolean,
  isLandingPage: boolean,
  isSellerSettings: boolean,
}
class Navigation extends Component<NavigationProps> {
  constructor(props) {
    super(props)
    this._closeLink = React.createRef()
  }
  componentDidMount() {
    // for a11y, set the focus on the close link everytime it renders
    if (this._closeLink.current) {
      this._closeLink.current.focus()
    }
  }

  getCurrentPath = history => {
    return _.get(history, 'location.pathname', '')
  }

  trackClick = linkName => {
    const currentPath = this.getCurrentPath(this.props.history)
    const isSellerRoute = currentPath.split('/')[1] === 'seller'

    // FPTI back instrumentation handled automatically via event handlers
    if (linkName === 'close') {
      trackAction('close')
    }

    if (isSellerRoute) {
      return this.trackSellerClick(linkName)
    }

    let pathName = currentPath.split('/')[2]
    const subPathName = currentPath.split('/')[3]
    if (subPathName) {
      pathName += `/${subPathName}`
    }

    const instrumentation = INSTRUMENTATION_MAP[pathName]
    const eventKey =
      instrumentation && instrumentation.NEW
        ? instrumentation.NEW[linkName]
        : null
    if (eventKey) {
      const eventFactory = Events[eventKey]
      if (typeof eventFactory === 'function') {
        tracking(eventFactory({}))
      } else {
        tracking({ event_name: eventKey })
      }
    }
  }
  trackSellerClick = linkName => {
    const slug = _.get(clientData, 'sellerProfileDetails.id')
    const currentPath = this.getCurrentPath(this.props.history)
    const hasSlugInUrl = slug && currentPath.includes(slug)
    const pathSplit = currentPath.split('/')
    if (!pathSplit.length) return

    // Start index if slug is there should be 3 so we can strip
    // out the slug to check SELLER_INSTRUMENTATION_MAP
    let index = hasSlugInUrl ? 3 : 2

    let pathName = pathSplit[index]
    index++

    while (index <= pathSplit.length - 1) {
      pathName += `/${pathSplit[index]}`
      index++
    }

    const INSTRUMENTATION = SELLER_INSTRUMENTATION_MAP[pathName]

    if (
      INSTRUMENTATION &&
      INSTRUMENTATION[linkName] &&
      Events[INSTRUMENTATION[linkName]]
    ) {
      if (pathName === 'error') {
        const {
          location: {
            state: {
              error: {
                headerKey = '',
                instrumentationObj: {
                  decisionMsg = '',
                  photoFlow = 'profile',
                  isMediaservError = false,
                },
              } = {},
            } = {},
          } = {},
        } = this.props.history
        if (headerKey === 'badPhoto') {
          tracking(
            Events[INSTRUMENTATION[linkName]]({
              error_source: 'image_screen',
              error_code: decisionMsg,
              photo_uploaded_flag: photoFlow,
            }),
          )
        } else if (headerKey === 'uploadPhoto' && isMediaservError) {
          // isMediaservError distinction is needed for instrumentation since Edit photo uses the same error codes to display the error screen
          tracking(
            Events[INSTRUMENTATION[linkName]]({
              error_source: 'mediaserv',
              error_code: 'SERVICE_ERROR',
              photo_uploaded_flag: photoFlow,
            }),
          )
        }
      } else {
        tracking(Events[INSTRUMENTATION[linkName]]({}))
      }
    }
  }
  handleBackButton = e => {
    const currentPath = this.getCurrentPath(this.props.history)
    if (e.type === 'click' || e.key === 'Enter') {
      this.trackClick('back')
      if (this.props.isMyProfile) {
        this.props.history.push('/my/settings')
      } else if (this.props.isSellerSettings) {
        this.props.history.push(currentPath.replace('/settings', '/dashboard'))
      } else {
        this.props.history.goBack()
      }
    }
  }
  componentDidUpdate() {
    if (this._closeLink.current) {
      this._closeLink.current.focus()
    }
  }

  renderBackButton = () => {
    const showBackLink = !(
      this.props.isSettingsPage ||
      this.props.isTimeoutPage ||
      this.props.isSuccessPage ||
      this.props.isLandingPage ||
      this.props.isSellerDashboard
    )

    return (
      <>
        {showBackLink ? (
          <NavLink
            tabIndex="0"
            onKeyDown={this.handleBackButton}
            onClick={this.handleBackButton}
            className="vx_backBtn vx_backBtn_flow"
            data-testid="p2p-back"
            aria-label={
              this.props.isMyProfile
                ? l10n('button.manage')
                : l10n('button.back')
            }
          >
            <span>
              {this.props.isMyProfile
                ? l10n('button.manage')
                : l10n('button.back')}
            </span>
          </NavLink>
        ) : null}
      </>
    )
  }

  render() {
    // the navigation flow is directionality specific and should always go
    // from left to right. So we'll make sure things flow that way here too
    return (
      <div style={{ padding: '0' }} dir="ltr">
        {this.renderBackButton()}
        {!this.props.isTimeoutPage ? (
          <a
            href={clientData.flowCancelUrl}
            className="vx_modal-dismiss_x-trigger"
            data-test-id="close-p2p"
            // custom top margin for close icon to center align it with back icon
            style={{ ...navigationItemStylingFix, marginTop: 22 }}
            ref={this._closeLink}
            aria-label={l10n('icon.close')}
            onClick={() => this.trackClick('close')}
          >
            <span className="vx_a11yText">{l10n('icon.close')}</span>
          </a>
        ) : null}
      </div>
    )
  }
}
type LayoutProps = {
  children: Node,
  history: RouterHistory,
  match: {
    url: string,
  },
}

// NOTE: Update all matches to use this function
/**
 *
 * @param {*} urlMatchArr - contains url split by '/'
 * @param {*} positions - array containing indices in urlMatchArr we want to check
 * @param {*} path - array containing path string to be matched with indices
 * @returns whether a url matches what we are expecting
 */
const matchUrl = (urlMatchArr, positions, paths) => {
  for (let i = 0; i < positions.length; i++) {
    if (urlMatchArr[positions[i]] !== paths[i]) {
      return false
    }
  }
  return true
}

class Layout extends Component<LayoutProps> {
  componentDidUpdate() {
    const overpanel = document.getElementById('core-white-overpanel-navigation')
    if (overpanel) {
      overpanel.scrollTop = 0
    }
  }
  render() {
    const urlMatchArr = this.props.match.url.split('/')
    const isMyProfile = urlMatchArr[2] === 'profile'
    const isSellerProfile = urlMatchArr[1] === 'seller'
    const isSettingsPage = urlMatchArr[2] === 'settings'
    const isSuccessPage = isSellerProfile && urlMatchArr[2] === 'success'
    const isLandingPage = isSellerProfile && urlMatchArr[2] === 'landing'
    const isSellerDashboard = isSellerProfile && urlMatchArr[3] === 'dashboard'
    const isSellerDashboardPreview =
      isSellerDashboard && urlMatchArr[4] === 'preview'
    const isSellerProducts = isSellerProfile && urlMatchArr[5] === 'products'
    // Match length to ensure it only matches '/settings' and not '/setttings/*'
    const isSellerSettings =
      isSellerProfile &&
      urlMatchArr[3] === 'settings' &&
      urlMatchArr.length === 4
    const isNewUser = _.get(clientData, 'myProfileData.isNewUser')
    const isTimeoutPage = urlMatchArr[2] === 'session-timeout'
    // We are expecting index 1 of urlMatchArr to be 'my' and index 2 to be 'createusername'
    const isPersonalProfileSlug = matchUrl(
      urlMatchArr,
      [1, 2],
      ['my', 'createusername'],
    )
    const isVisaPlus = matchUrl(urlMatchArr, [1], ['visa-plus'])
    const isFullScreen = isPersonalProfileSlug || isVisaPlus

    let WhiteWidth = '66.6%'
    let contentMarginTop = 104
    if (isFullScreen) {
      WhiteWidth = '100%'
      contentMarginTop = 0
    } else if (isSellerProfile) {
      WhiteWidth = '90%'
    }

    if (isSettingsPage) {
      contentMarginTop = 84
    }

    return (
      <Wrapper data-test-id="simple-layout">
        <SpinnerContainer id={SPINNER_ID} style={{ display: 'none' }}>
          <Spinner
            size={isVisaPlus ? 'xl' : 'lg'}
            screenReaderText={l10n('spinner.loading')}
            theme={isFullScreen ? 'v2' : 'v1'}
          />
        </SpinnerContainer>
        <White
          id="core-white-overpanel-navigation"
          isMyProfile={isMyProfile}
          isSellerProfile={isSellerProfile}
          isSellerDashboardPreview={isSellerDashboardPreview}
          isSellerProducts={isSellerProducts}
          isFullScreen={isFullScreen}
          WhiteWidth={WhiteWidth}
        >
          {!isFullScreen &&
            !isNewUser &&
            !isNativeApp &&
            !isSellerDashboardPreview && (
              <Navigation
                history={this.props.history}
                isMyProfile={isMyProfile}
                isSettingsPage={isSettingsPage}
                isSellerDashboard={isSellerDashboard}
                isTimeoutPage={isTimeoutPage}
                isSuccessPage={isSuccessPage}
                isLandingPage={isLandingPage}
                isSellerSettings={isSellerSettings}
              />
            )}
          <Content
            contentMarginTop={contentMarginTop}
            isSellerProfile={isSellerProfile}
            isSettingsPage={isSettingsPage}
            widerPage={isMyProfile || isSellerProfile}
            isFullScreen={isFullScreen}
          >
            {this.props.children}
          </Content>
        </White>
      </Wrapper>
    )
  }
}
export default withRouter(Layout)
